import { createContext } from '@fluentui/react-context-selector';
import type { GraphHook } from 'components/Graph/useGraph';
import {
  type ContextSelectorsHook,
  useContextSelectors,
} from 'utils/react/useContextSelectors';

/**
 * No default value:
 * https://medium.com/@rivoltafilippo/typing-react-context-to-avoid-an-undefined-default-value-2c7c5a7d5947
 */
export const GraphContext = createContext<GraphHook>(undefined!);

/**
 * Retrieve multiple values from graph hook context
 */
export const useGraphContextSelectors: ContextSelectorsHook<GraphHook> = (
  selectors,
) => useContextSelectors(GraphContext, selectors);
